import { Formik, Form } from 'formik'
import { object, string, number, SchemaOf } from 'yup'

import { FormAutocompleteProps, requiredFieldWithName } from '@collaborate-health/forms'
import { Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@collaborate-health/uikit'
import { CreateUserQualificationRequest } from '@tabeeb/contracts/microservices/swagger-certificate-service'

import { FormUserSelect } from '@tabeeb/shared/UserSearch'

import { QualificationVersionsAutocomplete } from '../Fields'

interface UserQualificationFormValues
  extends Pick<CreateUserQualificationRequest, 'AssignedToUserGuid' | 'QualificationVersionId'> {
  AssignedToUser: FormAutocompleteProps<number, unknown>['options'][0] | null
}

const schema: SchemaOf<UserQualificationFormValues> = object().shape({
  AssignedToUserGuid: string().nullable().required(requiredFieldWithName('User')),
  QualificationVersionId: number().nullable().required(requiredFieldWithName('Qualification version')),
  AssignedToUser: object()
    .shape({
      value: number().required(),
    })
    .nullable()
    .required(requiredFieldWithName('User')),
})

const initialValues: UserQualificationFormValues = {
  AssignedToUserGuid: '',
  QualificationVersionId: null!,
  AssignedToUser: null,
}

export interface AddUserQualificationDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: (values: CreateUserQualificationRequest) => void | Promise<void>
  onExited?: () => void
}

const AddUserQualificationDialog: React.FC<AddUserQualificationDialogProps> = ({
  open,
  onClose,
  onSubmit,
  onExited,
}) => {
  const handleSubmit = (values: UserQualificationFormValues) => {
    return onSubmit({
      AssignedToUserId: values.AssignedToUser!.value,
      AssignedToUserGuid: values.AssignedToUserGuid,
      QualificationVersionId: values.QualificationVersionId,
    })
  }

  return (
    <Dialog open={open} onClose={onClose} TransitionProps={{ onExited }} fullWidth maxWidth='sm'>
      <DialogTitle>Assign user qualification</DialogTitle>
      <Formik initialValues={initialValues} validationSchema={schema} onSubmit={handleSubmit}>
        {({ isValid, dirty, setFieldValue }) => (
          <Form autoComplete='off'>
            <DialogContent>
              <Grid container direction='row' spacing={2}>
                <Grid item xs={12}>
                  <FormUserSelect
                    name='AssignedToUser'
                    label='User'
                    onChange={(event, option) => {
                      setFieldValue('AssignedToUserGuid', option?.meta!.IdentityGuid)
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <QualificationVersionsAutocomplete name='QualificationVersionId' />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button color='primary' onClick={onClose}>
                Cancel
              </Button>
              <Button variant='contained' color='primary' type='submit' disabled={!(isValid && dirty)}>
                Assign
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

export default AddUserQualificationDialog

